import { gql } from 'apollo-angular';

const RESET_PASSWORD = gql`
  mutation requestPasswordReset($email: String!, $recaptchaToken: String!) {
    requestPasswordReset(
      input: { email: $email, recaptchaToken: $recaptchaToken }
    ) {
      success
    }
  }
`;

export default RESET_PASSWORD;
